// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
  justify-content: center;
}

i {
  font-size: 1.8rem;
  color: var(--grey-icon);
  cursor: pointer;
}

.calendar {
  background: var(--white);
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);
  position: absolute;
  top: 5.1rem;
  left: 0;
  z-index: 160;
  cursor: default;
}
.calendar .header {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}
.calendar .header .select {
  position: relative;
}
.calendar .header .select .value {
  font-size: 1.6rem;
  line-height: 1.9rem;
  font-weight: 500;
  color: var(--black);
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}
.calendar .header .select .value:after {
  content: "";
  border: 0.3rem solid transparent;
  border-right-color: var(--black);
  border-bottom-color: var(--black);
  display: block;
}
.calendar .header .select .dropdown {
  width: 10rem;
  max-height: 27rem;
  background: var(--white);
  border-radius: 0.8rem;
  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 3rem;
  right: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
}
.calendar .header .select .dropdown .option {
  min-height: 3rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  padding: 0 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}
.calendar .header .select .dropdown .option:hover {
  background: var(--basic-button-hover);
}
.calendar .header .select .dropdown .option.active {
  background: var(--primary-10);
  cursor: default;
}
.calendar .days {
  display: grid;
  grid-template-columns: repeat(7, 2.4rem);
  grid-gap: 1.2rem;
}
.calendar .days .cell {
  height: 2.4rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}
.calendar .days .cell.weekday {
  color: var(--primary);
  text-transform: uppercase;
  cursor: default;
}
.calendar .days .cell.selected {
  color: var(--white);
  background: var(--primary-30);
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/shared/date-picker/date-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;EACA,aAAA;EACA,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EACE,kBAAA;AACN;AACM;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;AACR;AACQ;EACE,WAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,cAAA;AACV;AAGM;EACE,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,qBAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,cAAA;AADR;AAGQ;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AADV;AAGU;EACE,qCAAA;AADZ;AAIU;EACE,6BAAA;EACA,eAAA;AAFZ;AASE;EACE,aAAA;EACA,wCAAA;EACA,gBAAA;AAPJ;AASI;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uCACE;AARR;AAWM;EACE,qBAAA;EACA,yBAAA;EACA,eAAA;AATR;AAYM;EACE,mBAAA;EACA,6BAAA;EACA,eAAA;AAVR","sourcesContent":[":host {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ni {\n  font-size: 1.8rem;\n  color: var(--grey-icon);\n  cursor: pointer;\n}\n\n.calendar {\n  background: var(--white);\n  padding: 3rem;\n  border-radius: 0.8rem;\n  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);\n  position: absolute;\n  top: 5.1rem;\n  left: 0;\n  z-index: 160;\n  cursor: default;\n\n  & .header {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    margin-bottom: 3rem;\n\n    & .select {\n      position: relative;\n\n      & .value {\n        font-size: 1.6rem;\n        line-height: 1.9rem;\n        font-weight: 500;\n        color: var(--black);\n        display: flex;\n        align-items: flex-end;\n        gap: 0.5rem;\n\n        &:after {\n          content: '';\n          border: 0.3rem solid transparent;\n          border-right-color: var(--black);\n          border-bottom-color: var(--black);\n          display: block;\n        }\n      }\n\n      & .dropdown {\n        width: 10rem;\n        max-height: 27rem;\n        background: var(--white);\n        border-radius: 0.8rem;\n        box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1);\n        display: flex;\n        flex-direction: column;\n        position: absolute;\n        top: 3rem;\n        right: 0;\n        left: 0;\n        z-index: 1;\n        overflow: auto;\n\n        & .option {\n          min-height: 3rem;\n          font-size: 1.2rem;\n          line-height: 1.4rem;\n          color: var(--black);\n          padding: 0 1rem;\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n          transition: background 0.2s;\n\n          &:hover {\n            background: var(--basic-button-hover);\n          }\n\n          &.active {\n            background: var(--primary-10);\n            cursor: default;\n          }\n        }\n      }\n    }\n  }\n\n  & .days {\n    display: grid;\n    grid-template-columns: repeat(7, 2.4rem);\n    grid-gap: 1.2rem;\n\n    & .cell {\n      height: 2.4rem;\n      font-size: 1.2rem;\n      line-height: 1.4rem;\n      color: var(--black);\n      border-radius: 0.2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      transition:\n        color 0.2s,\n        background 0.2s;\n\n      &.weekday {\n        color: var(--primary);\n        text-transform: uppercase;\n        cursor: default;\n      }\n\n      &.selected {\n        color: var(--white);\n        background: var(--primary-30);\n        cursor: default;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
